import React, {FunctionComponent} from 'react';
import {_ReactPixi, Container} from '@inlet/react-pixi';
import {Point} from 'pixi.js';
import {DeviceType, ScreenParameters} from '@gongxigames/framework/core';

export type LoaderContainerProps = Omit<_ReactPixi.IContainer, 'position' | 'scale'> & {
    platform: DeviceType;
    screenParameters: ScreenParameters;
};

const Y_OFFSETS = {
    DESKTOP: 1844,
    MOBILE_LANDSCAPE: 1624,
    MOBILE_PORTRAIT: 2304
} as const;

export const LoaderContainer: FunctionComponent<LoaderContainerProps> = (props) => {
    const {platform} = props;
    const {width, isPortraitOrientation, isLandscapeOrientation} = props.screenParameters;
    const scale = new Point(1, 1);
    const position = new Point(width / 2, 0);

    if (platform === DeviceType.DESKTOP) {
        position.y = Y_OFFSETS.DESKTOP;
    } else if (platform === DeviceType.MOBILE && isLandscapeOrientation) {
        position.y = Y_OFFSETS.MOBILE_LANDSCAPE;
    } else if (platform === DeviceType.MOBILE && isPortraitOrientation) {
        position.y = Y_OFFSETS.MOBILE_PORTRAIT;
    }

    return (
        <Container {...props} position={position} scale={scale} name='LoaderPlatformView'>
            {props.children}
        </Container>
    );
};
